

let AnnotationDefault = {
    drawTime: 'afterDatasetsDraw', // (default)

    annotations: []
}

export default AnnotationDefault;


// WEBPACK FOOTER //
// ./src/components/chart/objects/AnnotationDefault.js